import { last } from 'lodash'
import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

// Header, checar se vai quebrar algo
// export const Header = styled.header`
//   ${({ theme }) => css`
//     display: flex;
//     justify-content: space-between;
//     padding: 0 0 1rem;
//     margin-bottom: 1rem;
//     border-bottom: 1px solid ${theme.colors.inative};

//     aside {
//       display: flex;

//       > * + * {
//         margin-left: 1rem;
//       }
//     }
//   `}
// `

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3);

  .alertBrands {
    margin-bottom: 0.5rem;
  }
`

export const BulkSection = styled.section`
  ${({ theme }) => css`
    textarea {
      height: 20rem;
      max-height: 40vh;
    }

    .alertsForm {
      margin-bottom: 0.5rem;
    }
  `}
`

/**
 * List
 */

export const ProductsLists = styled.div`
  ${({ theme }) => css`
    @media ${device.laptop} {
      display: grid;

      grid-template-columns: repeat(2, minmax(320px, 1fr));

      margin-top: ${theme.spacings.xsmall};

      max-height: calc(80vh - 20px);
    }

    @media ${device.laptop_max} {
      display: flex;
      flex-direction: column;
    }

    ${ProductsList}:only-child {
      grid-column: 1 / -1;
      width: 100%;
      padding-bottom: 2rem;
    }
  `}
`

export const ProductsList = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    z-index: 5;
    position: relative;
    overflow-y: auto;

    max-height: calc(80vh - 20px);

    .empty {
      background: ${theme.colors.light};
      border-radius: 1rem;
      width: 100%;
      min-height: 40vh;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Space to scrollbar */

    &:first-child {
      @media ${device.laptop} {
        padding-right: 1rem;
      }

      @media ${device.laptop_max} {
        max-height: 75vh;
      }
    }

    &:last-child {
      @media ${device.laptop_max} {
        max-height: unset;
        min-height: unset;
      }

      @media ${device.laptop} {
        &:not(:first-child) {
          padding-right: 0.5rem;
          padding-left: 1rem;
          border-left: 1px solid ${theme.colors.tertiary};
        }
      }
    }

    /* width */
    ::-webkit-scrollbar {
      width: 0.5rem;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${theme.colors.inative};
      border-radius: 0.5rem;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.tertiary};
      transition: 0.3s ease-in-out all;
      border-radius: 0.5rem;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.gray};
    }

    > div + div {
      margin-top: ${theme.spacings.xsmall};
    }
  `}
`

export const ProductsListHeader = styled.header`
  ${({ theme }) => css`
    z-index: 10;
    position: sticky;
    top: 0;
    padding: 0 0 ${theme.spacings.xsmall} 0;
    background: ${theme.colors.white};

    .alertWrapper {
      margin: 0;
      margin-top: ${theme.spacings.xsmall};
    }
  `}
`

export const Heading = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`

export const Title = styled.h5`
  ${({ theme }) => css`
    /* display: flex; */
    /* align-items: flex-end; */
    margin-bottom: 0;
    line-height: 1;
    /* height: 2rem; */

    span {
      /* margin-left: 0.25rem; */
      font-size: 0.75em;
      color: ${theme.colors.neutral.low.medium};
    }
  `}
`

export const Info = styled.div`
  ${({ theme }) => css`
    border-radius: 0.25rem;
    padding: 0.5rem;
    background: rgba(170, 166, 221, 0.15);
    border-left: 0.125rem solid ${theme.colors.primary};

    > div {
      color: ${theme.colors.primary};
      font-size: 0.875rem;
      font-weight: 600;

      > svg {
        fill: ${theme.colors.primary};
        color: ${theme.colors.white};
        width: 1.313rem;
        height: 1.313rem;
      }
    }
  `}
`
export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;

  position: sticky;
  bottom: 0.5rem;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: saturate(80%) blur(5px);

  outline: 0.5rem rgba(255, 255, 255, 0.9) solid;

  > button {
    margin-left: 1rem;
  }
`
